import Icons from './utils/Icons.js';
import ComponentFactory from './ComponentFactory.js';

class Main {
  constructor() {
    this.init();
  }

  init() {
    // On ajoute une classe sur le html
    // pour qu'on puisse savoir si le JavaScript est
    // supporté dans notre css
    document.documentElement.classList.add('has-js');

    //new ComponentFactory(); N'oublie pas de l'importer
    new ComponentFactory();
    Icons.load();
  }
}
new Main();
